/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { CustomFieldGroupService } from 'app/core/services/custom_fields_group/custom_fields_group.service';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import _ from 'lodash';
import { NgxTippyProps } from 'ngx-tippy-wrapper';
import tippy from 'tippy.js';
import { ModuleAccess } from '../../components/dispatch-board/dispatch-board.interface';
import { LocalStorageService } from 'app/core/services/localstorage.service';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  tippyName: string;
  settingsDialogInstance: any;
  addNewAttributeRow: boolean = true;
  isNoTeamCreatedAlertIsOpened: boolean = false;
  refreshGridCards: boolean = true;
  moduleNameMap = { 'GRID': 'JOB', 'SCHEDULER': 'JOB', 'EMPLOYEE': 'EMPLOYEE', 'MAP': '', 'ROUTE': 'ROUTE' };
  jobAttributes: any = [];
  employeeAttributes: any = [];
  routeAttributes: any = [];
  routeCardAttributes: any = []; //Route attributes without default fields
  gridForm: UntypedFormGroup;
  schedulerForm: UntypedFormGroup;
  employeeForm: UntypedFormGroup;
  mapForm: UntypedFormGroup;
  defaultGridModuleValue: any;
  newToDispatchBoard: any;
  moduleFormMap: any;
  mapInitialValues: any;
  defaultGridCardView = { '1': [{ 'label': 'Job #', 'originalLabel': 'Job #', 'group_uid': 'work_order_number', 'group_name': 'Default Fields', 'type': 'SINGLE_LINE', 'value': '#98458', 'selector': 'work_order_number', 'dismissable': false, 'isDefaultField': true, 'key': 'work_order_number@Job-#', 'row': 1, 'column': 1, 'displayKey': 'dispatchBoard.grid.tbar.sort.job_id' }, { 'label': 'Job Title', 'originalLabel': 'Job Title', 'group_uid': 'work_order_title', 'group_name': 'Default Fields', 'type': 'SINGLE_LINE', 'value': 'Installation', 'selector': 'job_title', 'dismissable': false, 'isDefaultField': true, 'key': 'work_order_title@Job-Title', 'row': 1, 'column': 2, 'displayKey': 'text.job_title' }] };
  defaultGridTableView = [{ 'label': 'Job #', 'originalLabel': 'Job #', 'group_uid': 'work_order_number', 'group_name': 'Default Fields', 'type': 'SINGLE_LINE', 'value': '#98458', 'key': 'work_order_number@Job-#', 'isChecked': true, 'dismissable': false, 'isDefaultField': true, 'selector': 'work_order_number', 'displayKey': 'dispatchBoard.grid.tbar.sort.job_id' }, { 'label': 'Job Title', 'originalLabel': 'Job Title', 'group_uid': 'work_order_title', 'group_name': 'Default Fields', 'type': 'SINGLE_LINE', 'value': 'Installation', 'key': 'work_order_title@Job-Title', 'isChecked': true, 'dismissable': false, 'isDefaultField': true, 'selector': 'job_title', 'displayKey': 'text.job_title' }];
  routeSchedulerMaxEndDate: any;
  defaultRouteCardView = {
    '1': [
      {
        'label': 'Start Location',
        'group_uid': 'start_location',
        'group_name': 'Default Fields',
        'type': 'SINGLE_LINE',
        'value': '2nd Avenue, Seattle',
        'icon': 'ti ti-map-pin',
        'selector': 'start_location',
        'dismissable': true,
        'isDefaultField': true,
        'key': 'start_location@Start-Location',
        'row': 1,
        'column': 1,
        'displayKey': 'text.start_location'
      },
      {
        'label': 'End Location',
        'group_uid': 'end_location',
        'group_name': 'Default Fields',
        'type': 'SINGLE_LINE',
        'value': '4th Block, Hillcrest',
        'icon': 'ti ti-map-pin',
        'selector': 'end_location',
        'dismissable': true,
        'isDefaultField': true,
        'key': 'end_location@End-Location',
        'row': 1,
        'column': 2,
        'displayKey': 'text.end_location'
      }
    ]
  };
  defaultRouteTableView = [{
    'label': 'Route Name',
    'group_uid': 'route_name',
    'group_name': 'Default Fields',
    'type': 'SINGLE_LINE',
    'value': 'Route for July 18',
    'selector': 'route_name',
    'dismissable': false,
    'isDefaultField': true,
    'key': 'route_name@Route-Name',
    'isChecked': true,
    'displayKey': 'text.route_name'
  }];
  defaultEmployeeCardView = { '1': [{ 'label': 'Technician Name', 'group_uid': 'employee_name', 'group_name': 'Default Fields', 'type': 'SINGLE_LINE', 'value': 'Peter Thornton', 'selector': 'name', 'dismissable': false, 'isDefaultField': true, 'key': 'employee_name@Technician-Name', 'row': 1, 'column': 1 }] };
  allJobAttributes: any;
  allEmployeeAttributes: any;
  allRouteAttributes: any;
  isLocaleValueAvailable = { job: false, employee: false, route: false };

  constructor(
    private _dataCollectorService: DataCollectorService,
    private _customFieldGroupService: CustomFieldGroupService,
    private formBuilder: UntypedFormBuilder,
    private _localStorageService: LocalStorageService,
    private utilityService: UtilityService
  ) {
  }

  async initateForms(getaAllAttributes: boolean = true): Promise<void> {
    this.gridForm = this.formBuilder.group({
      primary_color: ['jobStatus', Validators.required],
      secondary_color: ['team', Validators.required],
      job_count: [10, Validators.required],
      view_type: ['listView', Validators.required],
      card_view: [this.defaultGridCardView, Validators.required],
      table_view: [this.defaultGridTableView, Validators.required],
      table_grid_position: ['LEFT', Validators.required],
      route_card_view: [this.defaultRouteCardView, Validators.required],
      route_table_view: [this.defaultRouteTableView, Validators.required]
    });

    this.schedulerForm = this.formBuilder.group({
      primary_color: ['jobStatus', Validators.required],
      secondary_color: ['team', Validators.required],
      card_view: [this.defaultGridCardView, Validators.required],
      mode_of_transport: ['CAR', Validators.required],
      display: this.formBuilder.group({
        multiple_teams: [false, Validators.required],
        business_hours_only: [false, Validators.required],
        duration_between_jobs: [false, Validators.required],
        job_summary: [false, Validators.required],
        weekends: [false, Validators.required],
        week_numbers: [false, Validators.required]
      })
    });

    this.employeeForm = this.formBuilder.group({
      profile: ['with_avatar', Validators.required],
      card_view: [this.defaultEmployeeCardView, Validators.required],
      more_information: this.formBuilder.group({
        skillset: [false, Validators.required],
        role: [false, Validators.required],
        work_hours: [false, Validators.required],
        timesheet_status: [false, Validators.required],
        capacity: [false, Validators.required]
      })
    });

    this.mapForm = this.formBuilder.group({
      enable_map_view: [false, Validators.required],
      nearby_jobs: [true, Validators.required],
      layers: this.formBuilder.group({
        jobs: [false, Validators.required],
        routes: [false, Validators.required],
        users: [false, Validators.required],
        organizations: [false, Validators.required],
        properties: [false, Validators.required],
        customers: [false, Validators.required],
        service_territories: [false, Validators.required],
        assets: [false, Validators.required]
      })
    });
    this.mapInitialValues = this.mapForm.value;
    this.moduleFormMap = { 'GRID': this.gridForm, 'SCHEDULER': this.schedulerForm, 'EMPLOYEE': this.employeeForm, 'MAP': this.mapForm };
    if (getaAllAttributes) {
      this.getAllAttributes();
    }
  }

  async getJobAttributes(): Promise<any> {
    if (this.allJobAttributes?.length) {
      this.jobAttributes = this.isLocaleValueAvailable.job ? this.allJobAttributes : this.allJobAttributes.map(ele => ({ ...ele, displayKeyValue: ele?.displayKey ? this.utilityService.getLocaleValue(ele.displayKey) : ele.label }));
    }
    else {
      [this.jobAttributes, this.isLocaleValueAvailable.job] = await this.getDefaultAndCustomFields('GRID');
      this.allJobAttributes = this.jobAttributes;
    }
    if (this.allEmployeeAttributes?.length) {
      this.employeeAttributes = this.isLocaleValueAvailable.employee ? this.allEmployeeAttributes : this.allEmployeeAttributes.map(ele => ({ ...ele, displayKeyValue: ele?.displayKey ? this.utilityService.getLocaleValue(ele.displayKey) : ele.label }));
    }
    else {
      [this.employeeAttributes, this.isLocaleValueAvailable.employee] = await this.getDefaultAndCustomFields('EMPLOYEE');
      this.allEmployeeAttributes = this.employeeAttributes;
    }
  }

  async getRouteAttributes(): Promise<any> {
    let routeAttributes: any[] = [];
    if (this.allRouteAttributes?.length) {
      routeAttributes = this.isLocaleValueAvailable.route ? this.allRouteAttributes : this.allRouteAttributes.map(ele => ({ ...ele, displayKeyValue: ele?.displayKey ? this.utilityService.getLocaleValue(ele.displayKey) : ele.label }));
    }
    else {
      [routeAttributes, this.isLocaleValueAvailable.route] = await this.getDefaultAndCustomFields('ROUTE');
      this.allRouteAttributes = routeAttributes;
    }
    this.routeCardAttributes = routeAttributes.filter((attributes: any) => !attributes?.isDeleted);
    this.routeAttributes = routeAttributes;
  }

  async getAllAttributes(): Promise<void> {
    await this.getJobAttributes();
    await this.getRouteAttributes();
  }

  updateFormFields(form: any, formControlName: string, value: any): void {
    const formValue: any = {};
    formValue[formControlName] = value;
    form.patchValue(formValue);
  }

  getDefaultAndCustomFields(moduleName: string, onlyDefaultFields: boolean = false): Promise<any> {
    return new Promise(async (resolve) => {
      let customeFields = [];
      let defaultFields = this.getDefaultFields(moduleName);
      const isLocaleValueAvailable: boolean = !_.isEmpty(this.utilityService.localizationValue);
      defaultFields = defaultFields.map(ele => ({ ...ele, isDefaultField: true, displayKeyValue: ele?.displayKey ? this.utilityService.getLocaleValue(ele.displayKey) : ele.label }));
      if (!onlyDefaultFields) {
        if (moduleName !== 'ROUTE') {
          customeFields = this._customFieldGroupService.constructCustomFieldUpdateObject(await this.getCustomFields(this.moduleNameMap[moduleName]));
        }
        customeFields = customeFields.map(ele => ({
          ...ele, isDefaultField: false, group_name: ele.group_name.replace('Custom fields - ', ''), displayKeyValue: ele.label,
          tooltip: `${ele.label} (${ele.group_name})`, originalLabel: ele.label, label: `${ele.label} (${ele.group_name.replace('Custom fields - ', '')})`
        }));
      }
      resolve([[...defaultFields, ...customeFields]
        .map(ele => ({ ...ele, key: this.generateKey(ele.group_uid, ele.label) })), isLocaleValueAvailable]);
    });
  }

  generateKey(group_uid: string, label: string): string {
    group_uid = group_uid === '' ? 'default_uid' : group_uid;
    return group_uid.trim() + '@' + label.trim().replaceAll(' ', '-');
  }

  addMissingKey(obj1: any, obj2: any): any {
    const skipKeys = ['due_date_type', 'schedule_date_type'];
    Object.keys(obj2).forEach((key) => {
      if (!obj1.hasOwnProperty(key) && !skipKeys.includes(obj2)) {
        obj1[key] = '';
      }
    });
    return obj1;
  }

  isEqualObjects(object1: any, object2: any, skipKeys?: string[]): boolean {
    const _object1 = _.omit(object1, skipKeys);
    const _object2 = _.omit(object2, skipKeys);
    return _.isEqual(_.pick(_object1, Object.keys(_object2)), _object2);
  }

  getCustomFields(moduleName: string): Promise<any> {
    return new Promise((resolve, reject) => {
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      this._dataCollectorService.getData(this._customFieldGroupService.getModuleCustomFieldsUrl(moduleName))
        .subscribe((response) => {
          resolve(response.data);
        }),
        (_err: any): any => {
          resolve([] as any);
        };
    });
  }

  createTippy(target: Element, options: NgxTippyProps): any {
    if (target) {
      return tippy(target, options);
    }
  }

  saveMetaData(moduleAccess: ModuleAccess): void {
    if(!moduleAccess.map) {
      this.mapForm.reset(this.mapInitialValues);
    }
    const gridData = this.gridForm.value;
    const schedulerData = this.schedulerForm.value;
    const employeeData = this.employeeForm.value;
    const mapData = this.mapForm.value;
    if (gridData?.view_type === 'listView') {
      gridData.table_grid_position = 'LEFT';
    }
    const settingsData = { 'grid': gridData, 'scheduler': schedulerData, 'employee': employeeData, 'map': mapData };
    if (!_.isEqual(this.defaultGridModuleValue, settingsData) || this.newToDispatchBoard) {
      const payload = { 'meta_data': { 'module': 'SCHEDULE', 'key': 'DISPATCH_BOARD_V3', 'value': JSON.stringify(settingsData) } };
      const metaDataUrl = `${this._dataCollectorService.baseUrl}//meta_data`;
      this._dataCollectorService.postData(metaDataUrl, payload)
        .subscribe((response) => {
          this._localStorageService.setLocalStorage('dispatch_board_metadata', settingsData);
          this._localStorageService.setLocalStorage('calendar_metadata', settingsData);
          this.defaultGridModuleValue = settingsData;
          this.settingsDialogInstance.close(settingsData);
        });
    }
    else {
      this.settingsDialogInstance?.close();
    }
  }

  initAddAttributeRowBtn(): void {
    this.addNewAttributeRow = !this.addNewAttributeRow;
    setTimeout(() => {
      this.addNewAttributeRow = !this.addNewAttributeRow;
    });
  }

  getDefaultFields(moduleName: string): any[] {
    const defaultFields = {
      'JOB': [
        {
          'label': 'Job #',
          'group_uid': 'work_order_number',
          'group_name': 'Default Fields',
          'type': 'SINGLE_LINE',
          'value': '#98458',
          'selector': 'work_order_number',
          'dismissable': false,
          'displayKey': 'dispatchBoard.grid.tbar.sort.job_id'
        },
        {
          'label': 'Job Title',
          'group_uid': 'work_order_title',
          'group_name': 'Default Fields',
          'type': 'SINGLE_LINE',
          'value': 'Installation',
          'selector': 'job_title',
          'dismissable': false,
          'displayKey': 'text.job_title'
        },
        {
          'label': 'Job Category',
          'group_uid': 'work_order_category',
          'group_name': 'Default Fields',
          'type': 'SINGLE_LINE',
          'value': 'Home cleaning',
          'selector': 'job_category.category_name',
          'icon': 'ti ti-category-2',
          'dismissable': true,
          'displayKey': 'job.category'
        },
        {
          'label': 'Current Job Status',
          'group_uid': 'current_work_order_status',
          'group_name': 'Default Fields',
          'type': 'SINGLE_LINE',
          'value': 'Started',
          'status_color_selector': 'current_job_status.status_color',
          'selector': 'current_job_status.status_name',
          'dismissable': true,
          'displayKey': 'dispatchBoard.settings.label.current_job_status'
        },
        {
          'label': 'Priority',
          'group_uid': 'work_order_priority',
          'group_name': 'Default Fields',
          'type': 'SINGLE_LINE',
          'value': 'Medium',
          'selector': 'job_priority',
          'dismissable': true,
          'displayKey': 'text.priority'
        },
        {
          'label': 'Property',
          'group_uid': 'work_order_property',
          'group_name': 'Default Fields',
          'type': 'SINGLE_LINE',
          'value': 'Real Estate',
          'selector': 'property.property_name',
          'icon': 'ti ti-building-estate',
          'dismissable': true,
          'displayKey': 'text.property'
        },
        {
          'label': 'Actual Date & Time',
          'group_uid': 'work_order_actual_date',
          'group_name': 'Default Fields',
          'type': 'DATE',
          'value': '02/02/2024 09:00 -> 11:30',
          'selector': ['actual_start_time', 'actual_end_time'],
          'icon': 'ti ti-calendar',
          'dismissable': true,
          'displayKey': 'dispatchBoard.settings.label.actual_date'
        },
        {
          'label': 'Created Date',
          'group_uid': 'work_order_created_date',
          'group_name': 'Default Fields',
          'type': 'DATE',
          'value': '09/12/2023',
          'selector': 'created_at',
          'icon': 'ti ti-calendar-plus',
          'dismissable': true,
          'displayKey': 'customer.filter.created_at'
        },
        {
          'label': 'Customer Name',
          'group_uid': 'work_order_customer_name',
          'group_name': 'Default Fields',
          'type': 'SINGLE_LINE',
          'value': 'Jose-Manuel',
          'selector': ['customer.customer_first_name', 'customer.customer_last_name'],
          'icon': 'ti ti-user-circle',
          'dismissable': true,
          'displayKey': 'text.customer_name'
        },
        {
          'label': 'Organization Name',
          'group_uid': 'work_order_organization_name',
          'group_name': 'Default Fields',
          'type': 'SINGLE_LINE',
          'value': 'Meta',
          'selector': 'organization.organization_name',
          'icon': 'ti ti-building',
          'dismissable': true,
          'displayKey': 'text.organization_name'
        },
        {
          'label': 'Service Address - Street',
          'group_uid': 'service_address_street',
          'group_name': 'Default Fields',
          'type': 'SINGLE_LINE',
          'value': '2nd Avenue',
          'selector': 'customer_address.street',
          'icon': 'ti ti-building',
          'dismissable': true,
          'displayKey': 'dispatchBoard.settings.label.service_address_street'
        },
        {
          'label': 'Service Address - City & State',
          'group_uid': 'service_address_city_state',
          'group_name': 'Default Fields',
          'type': 'SINGLE_LINE',
          'value': 'Washington',
          'selector': ['customer_address.city', 'customer_address.state'],
          'icon': 'ti ti-location',
          'dismissable': true,
          'displayKey': 'dispatchBoard.settings.label.service_address_city_state'
        },
        {
          'label': 'Service Address - Zipcode',
          'group_uid': 'service_address_zipcode',
          'group_name': 'Default Fields',
          'type': 'SINGLE_LINE',
          'value': '20001',
          'selector': 'customer_address.zip_code',
          'icon': 'ti ti-map-pin',
          'dismissable': true,
          'displayKey': 'dispatchBoard.settings.label.service_address_zipcode'
        },
        {
          'label': 'Assigned To',
          'group_uid': 'work_order_assigned_to',
          'group_name': 'Default Fields',
          'type': 'SINGLE_LINE',
          'value': 'John Charles',
          'selector': 'assigned_to',
          'icon': 'ti ti-users',
          'dismissable': true,
          'displayKey': 'text.assigned_to'
        },
        {
          'label': 'Skillsets',
          'group_uid': 'work_order_skillsets',
          'group_name': 'Default Fields',
          'type': 'SINGLE_LINE',
          'value': 'Plumbing',
          'selector': 'skills',
          'icon': '',
          'dismissable': true,
          'displayKey': 'dispatchBoard.settings.label.skillsets'
        },
        {
          'label': 'Scheduled Date & Time',
          'group_uid': 'work_order_scheduled_date',
          'group_name': 'Default Fields',
          'type': 'DATE',
          'value': '02/02/2024 09:00 AM -> 02/02/2024 10:00 AM',
          'selector': ['scheduled_start_time', 'scheduled_end_time'],
          'icon': 'ti ti-calendar-time',
          'dismissable': true,
          'displayKey': 'dispatchBoard.settings.label.scheduled_start_date_time'
        },
        {
          'label': 'Due Date',
          'group_uid': 'work_order_due_date',
          'group_name': 'Default Fields',
          'type': 'DATE',
          'value': '02/02/2024',
          'selector': 'due_date',
          'icon': 'ti ti-calendar-due',
          'dismissable': true,
          'displayKey': 'due.date.text'
        },
        {
          'label': 'Service Territory',
          'group_uid': 'service_territory',
          'group_name': 'Default Fields',
          'type': 'SINGLE_LINE',
          'value': 'North East Region',
          'selector': 'service_territory.territory.territory_name',
          'icon': 'ti ti-compass',
          'dismissable': true,
          'displayKey': 'dispatch.filter.service_territory.label'
        },
        {
          'label': 'Tags',
          'group_uid': 'job_tags',
          'group_name': 'Default Fields',
          'type': 'SINGLE_LINE',
          'value': 'Needs Triage',
          'selector': 'job_tags',
          'icon': 'ti ti-tag',
          'dismissable': true,
          'displayKey': 'text.tags'
        }
      ],
      'EMPLOYEE': [
        {
          'label': 'Technician Name',
          'group_uid': 'employee_name',
          'group_name': 'Default Fields',
          'type': 'SINGLE_LINE',
          'value': 'Peter Thornton',
          'selector': 'name',
          'icon': '',
          'dismissable': false,
          'displayKey': 'dispatchBoard.settings.label.technician_name'
        },
        // {
        //   'label': 'Status',
        //   'group_uid': 'employee_status',
        //   'group_name': 'Default Fields',
        //   'type': 'SINGLE_LINE',
        //   'value': 'Available',
        //   'selector': 'is_active',
        //   'dismissable': true,
        //   'displayKey': 'status.text',
        // },
        {
          'label': 'Skillset',
          'group_uid': 'employee_skillset',
          'group_name': 'Default Fields',
          'type': 'SINGLE_LINE',
          'value': 'Plumbing',
          'selector': 'user_skills',
          'icon': 'ti ti-tool',
          'dismissable': true,
          'displayKey': 'dispatchBoard.settings.employee.more_information.skillset'
        },
        {
          'label': 'Job/Route count',
          'group_uid': 'employee_job_count',
          'group_name': 'Default Fields',
          'type': 'SINGLE_LINE',
          'value': '2',
          'selector': 'job_count',
          'icon': 'ti ti-briefcase',
          'dismissable': true,
          'displayKey': 'dispatchBoard.settings.label.event_count'
        },
        {
          'label': 'Role',
          'group_uid': 'employee_role',
          'group_name': 'Default Fields',
          'type': 'SINGLE_LINE',
          'value': 'Field Executive',
          'selector': 'role_name',
          'icon': 'ti ti-user',
          'dismissable': true,
          'displayKey': 'role.text'
        },
        {
          'label': 'Work Hours',
          'group_uid': 'employee_work_hours',
          'group_name': 'Default Fields',
          'type': 'SINGLE_LINE',
          'value': '09:00 - 17:00',
          'selector': 'work_hours',
          'icon': 'ti ti-clock-hour-2',
          'dismissable': true,
          'displayKey': 'text.work_hours'
        },
        {
          'label': 'Designation',
          'group_uid': 'employee_designation',
          'group_name': 'Default Fields',
          'type': 'SINGLE_LINE',
          'value': 'Admin',
          'selector': 'designation',
          'icon': 'ti ti-id',
          'dismissable': true,
          'displayKey': 'users.table.designation'
        }
      ],
      'ROUTE': [
        {
          'label': 'Route Name',
          'group_uid': 'route_name',
          'group_name': 'Default Fields',
          'type': 'SINGLE_LINE',
          'value': 'Route for July 18',
          'selector': 'route_name',
          'dismissable': false,
          'isDeleted': true,
          'displayKey': 'text.route_name'
        },
        {
          'label': 'Departure',
          'group_uid': 'departure',
          'group_name': 'Default Fields',
          'type': 'DATE',
          'value': '19/07/2023',
          'selector': 'departure',
          'icon': 'ti ti-calendar-due',
          'dismissable': true,
          'displayKey': 'text.departure'
        },
        {
          'label': 'Duration',
          'group_uid': 'duration',
          'group_name': 'Default Fields',
          'type': 'SINGLE_LINE',
          'value': '8 hrs',
          'selector': 'duration',
          'icon': 'ti ti-clock',
          'dismissable': true,
          'isDeleted': true,
          'displayKey': 'route.label.duration'
        },
        {
          'label': 'Start Location',
          'group_uid': 'start_location',
          'group_name': 'Default Fields',
          'type': 'SINGLE_LINE',
          'value': '2nd Avenue, Seattle',
          'icon': 'ti ti-map-pin',
          'selector': 'start_location',
          'dismissable': true,
          'displayKey': 'text.start_location'
        },
        {
          'label': 'End Location',
          'group_uid': 'end_location',
          'group_name': 'Default Fields',
          'type': 'SINGLE_LINE',
          'value': '4th Block, Hillcrest',
          'icon': 'ti ti-map-pin',
          'selector': 'end_location',
          'dismissable': true,
          'displayKey': 'text.end_location'
        },
        {
          'label': 'Created Date',
          'group_uid': 'created_date',
          'group_name': 'Default Fields',
          'type': 'DATE',
          'value': '09/12/2023',
          'selector': 'created_at',
          'icon': 'ti ti-calendar-plus',
          'dismissable': true,
          'displayKey': 'customer.filter.created_at'
        },
        {
          'label': 'Total Jobs',
          'group_uid': 'total_jobs',
          'group_name': 'Default Fields',
          'type': 'SINGLE_LINE',
          'value': '5',
          'selector': 'total_jobs',
          'icon': 'ti ti-briefcase',
          'dismissable': true,
          'isDeleted': true,
          'displayKey': 'text.total_jobs'
        },
        {
          'label': 'Transport Mode',
          'group_uid': 'transport_mode',
          'group_name': 'Default Fields',
          'type': 'SINGLE_LINE',
          'value': 'Truck',
          'selector': 'transport_mode',
          'icon': 'ti ti-truck',
          'dismissable': true,
          'displayKey': 'dispatchBoard.settings.label.transport_mode'
        }
      ],
    };
    if(this.utilityService.hasModuleAccess('PROJECT')) {
      const projectAttribute = {
        'label': 'Project',
        'group_uid': 'job_project',
        'group_name': 'Default Fields',
        'type': 'SINGLE_LINE',
        'value': 'Kitchen Installation - Henry',
        'icon': 'ti ti-clipboard-check',
        'selector': 'project',
        'dismissable': true,
        'displayKey': 'text.project'
      };
      defaultFields.JOB.push(projectAttribute);
    }

    return defaultFields[this.moduleNameMap[moduleName]] || [];
  }
}
export interface SelectedCardDetails {
  label: string;
  key: string;
  row: number;
  column: number;
  dismissable: boolean;
}
